export const ClosedEnvelopeIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.99984 4.60872L9.4766 9.64621C10.0785 10.1143 10.9212 10.1143 11.5231 9.64621L17.9998 4.60872M4.83317 17.1087H16.1665C17.0999 17.1087 17.5666 17.1087 17.9232 16.9271C18.2368 16.7673 18.4917 16.5123 18.6515 16.1987C18.8332 15.8422 18.8332 15.3755 18.8332 14.4421V6.44206C18.8332 5.50864 18.8332 5.04193 18.6515 4.68541C18.4917 4.3718 18.2368 4.11684 17.9232 3.95705C17.5666 3.77539 17.0999 3.77539 16.1665 3.77539H4.83317C3.89975 3.77539 3.43304 3.77539 3.07652 3.95705C2.76292 4.11684 2.50795 4.3718 2.34816 4.68541C2.1665 5.04193 2.1665 5.50864 2.1665 6.44206V14.4421C2.1665 15.3755 2.1665 15.8422 2.34816 16.1987C2.50795 16.5123 2.76292 16.7673 3.07652 16.9271C3.43304 17.1087 3.89975 17.1087 4.83317 17.1087Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
